import React, { useEffect, useMemo, useState } from "react";
import { getConfig } from "../../../../network/auth";
import { baseUrl } from "../../../../network/constants/constants";
import axios from "../../../../network/api";
import PaymentTable from "./component/paymentTable";
import FilterDate from "./component/filterDate";
import { Row, Col, Spinner } from "react-bootstrap";
import { Snackbar, Alert } from "@mui/material";
import * as XLSX from "xlsx";
import "./paymentReport.css";
import AppConstants from "../../../AppConstants";

const BusinessPaymentReport = () => {
  const [pagination, setPagination] = useState({
    pageSize: 25,
    page: 1,
  });

  const [paymentReport, setPaymentReport] = useState([]);
  const [forFilterReport, setForFilterResport] = useState([]);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const [loading, setLoading] = useState(false);
  const bID = localStorage.getItem(AppConstants.business_id);
  const config = useMemo(() => {
    return getConfig();
  }, []);

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const fetchPaymentReport = (start_date = null, end_date = null) => {
    setLoading(true);
    axios
      .get(`${baseUrl}payment/payment-report-by-business/${bID}`, {
        params: {
          start_date: start_date || "",
          end_date: end_date || "",
          // page: pagination.page || 1,
          // size: pagination.pageSize || 25
        },
        ...config,
      })
      .then((response) => {
        setPaymentReport(response.data);
        setForFilterResport(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Franchise Error:", error);
        setLoading(false);
      });
  };

  const handleFilterPayment = () => {
    if (!paymentReport || paymentReport.length === 0) {
      setSnackbarMessage("No payment records to filter.");
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    }

    if (!startDate || !endDate) {
      setSnackbarMessage("Please select both start and end dates.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    if (paymentReport.length === 0) {
      setSnackbarMessage("No records found within the selected range.");
      setSnackbarSeverity("info");
      setSnackbarOpen(true);
    } else {
      setSnackbarMessage("Filters applied successfully.");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    }
    fetchPaymentReport(startDate, endDate);
  };

  const exportToExcel = () => {
    const filteredReport = forFilterReport.map(
      ({ booking, business_id, user_id, other_service, ...rest }) => rest
    );
    const worksheet = XLSX.utils.json_to_sheet(filteredReport);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "paymentDetails");
    XLSX.writeFile(workbook, "paymentDetails.xlsx");

    setSnackbarMessage("Excel sheet downloaded successfully.");
    setSnackbarSeverity("success");
    setSnackbarOpen(true);
  };

  const handleReset = () => {
    setStartDate("");
    setEndDate("");
    fetchPaymentReport();
    setSnackbarMessage("Filter reset. Showing all data.");
    setSnackbarSeverity("info");
    setSnackbarOpen(true);
    setForFilterResport();
  };

  useEffect(() => {
    fetchPaymentReport();
  }, []);

  return (
    <div className="booking-details mt-4">
      {loading ? (
        <div className="loader-container">
          <Spinner className="spinner-loader" />
        </div>
      ) : (
        <>
          <Row className="mb-2">
            <Col>
              <FilterDate
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
                onExport={exportToExcel}
                onReset={handleReset}
                handleFilterPayment={handleFilterPayment}
              />
            </Col>
          </Row>
          <PaymentTable
            paymentReport={forFilterReport}
            startDate={startDate}
            endDate={endDate}
            handleFilterPayment={handleFilterPayment}
            setPagination={setPagination}
          />
          <Snackbar
            open={snackbarOpen}
            autoHideDuration={3000}
            onClose={handleCloseSnackbar}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity}>
              {snackbarMessage}
            </Alert>
          </Snackbar>
        </>
      )}
    </div>
  );
};

export default BusinessPaymentReport;
